
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { deepClone } from "@/utils/deepClone";
import { exportJson2Excel } from "@/utils/excel";
import { formatJson } from "@/utils";

@Component({
  name: "ModifyDiscounts"
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "查看产品列表" }) private title: "";
  @Prop({ default: {} }) private info: {} | any;
  @Watch("show", { immediate: true })
  private async watchData() {
    // this.getPiCombinedUnit();
  }

  private form = {} as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[]
  };
  public tableCol = [
    {
      label: "Product Name",
      prop: "declarationDescription",
      key: "declarationDescription",
      show: true,
      disabled: false
    },
    {
      label: "Customer No.",
      prop: "guestModel",
      key: "guestModel",
      show: true,
      disabled: false
    },
    {
      label: "H&Q No.",
      prop: "hqOrJrNumber",
      key: "hqOrJrNumber",
      show: true,
      disabled: false
    },
    {
      label: "OE No.",
      prop: "oeNumber",
      key: "oeNumber",
      show: true,
      disabled: false
    },
    {
      label: "REF No.",
      prop: "refNumber",
      key: "refNumber",
      show: true,
      disabled: false
    },
    {
      label: "QTY",
      prop: "totalNumberPcs",
      key: "totalNumberPcs",
      show: true,
      disabled: false
    },
    {
      label: "UNIT PRICE",
      prop: "unitPrice",
      key: "unitPrice",
      account: ['A','A_B'],
      show: true,
      disabled: false
    },
    {
      label: "TOTAL SUM",
      prop: "totalSum",
      key: "totalSum",
      account: ['A','A_B'],
      show: true,
      disabled: false
    },
    {
      label: "UNIT PRICE",
      prop: "companyDiscountPrice",
      key: "companyDiscountPrice",
      account: ['B','A_B'],
      show: true,
      disabled: false
    },
    {
      label: "TOTAL SUM",
      prop: "totalSumCompanyPrice",
      key: "totalSumCompanyPrice",
      account: ['B','A_B'],
      show: true,
      disabled: false
    },
    {
      label: "PO",
      prop: "poNumber",
      key: "poNumber",
      show: true,
      disabled: false
    }
  ] as any;

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }


  private async submitForm(): Promise<void> {
    //
  }
  // 导出excel
  private isExporting = false;
  public handleExport() {
    this.isExporting = true;
    let table = this.tableCol
    const headers = table.map((v) => v.label);
    const fieldNames = table.map((v) => v.key);
    let list = deepClone(this.info.productList);
    exportJson2Excel(
      headers,
      formatJson(fieldNames, list),
      `产品列表-${new Date()}`
    );
    this.isExporting = false;
  }


}
